// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getAuth } from "firebase/auth";
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDkZwy9okC3R7ZxmPH45hRkeLA4r8ObTjE",
  authDomain: "infinite-digital.firebaseapp.com",
  projectId: "infinite-digital",
  storageBucket: "infinite-digital.appspot.com",
  messagingSenderId: "60248539477",
  appId: "1:60248539477:web:47437c60e7559dd7cf2fdc",
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
